import classNames from 'classnames';
import { forwardRef } from 'react';
import { selectAll as selectAllCalendarAccounts, useFetchCalendarAccountsQuery } from 'features/calendar_connections';
import { PushCalendarsCardDropdown } from './push_calendars_card_dropdown';
import { SyncSettings } from './sync_settings';
const containerCss = "c1chsg2s";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Section = () => {
  const {
    data
  } = useFetchCalendarAccountsQuery();
  const accounts = selectAllCalendarAccounts(data);
  const {
    uuid
  } = accounts.find(account => account.pushEnabled) || {};
  return <Container>
      <PushCalendarsCardDropdown pushAccountUuid={uuid} />
      <SyncSettings pushAccountUuid={uuid} />
    </Container>;
};

require("./section.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./section.js");